import { useGetExternalIntegrationsQuery } from '../../queries/Integrations/useGetExternalIntegrations';
import { hasNonProfitIntegrationEnabled } from '../utils/integrationUtils';
import { useUserSession } from './appStateHooks';

/**
 * Whether the account has a donor-management integration (v1 DonorPerfect, or v2 DonorPerfect or Bloomerang).
 * `isPending` stays true until the v2 integrations load; a v1 DonorPerfect account is already known before then.
 */
export const useHasNonProfitIntegration = () => {
	const userSession = useUserSession();
	const externalIntegrationsQuery = useGetExternalIntegrationsQuery({ impersonationContext: undefined });
	return {
		hasNonProfitIntegration: hasNonProfitIntegrationEnabled(
			userSession.account?.integrations,
			externalIntegrationsQuery.data
		),
		isPending: externalIntegrationsQuery.isPending,
	};
};
